import { Component, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DateRangeService } from './core/services/date-range.service';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, FormsModule, ButtonModule, TooltipModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  readonly dateRange = inject(DateRangeService);
  readonly auth = inject(AuthService);
  private readonly msal = inject(MsalService);
  readonly isDark = signal(false);

  ngOnInit(): void {
    // MSAL must (a) initialize itself in v3 before any instance call, and
    // (b) process the redirect response on app boot — without (b) the hash
    // fragment (#code=...) returned by Entra is never consumed and the user
    // appears to be stuck in a redirect loop.
    this.msal.initialize().subscribe(() => {
      this.msal.instance.handleRedirectPromise().then(() => {
        this.auth.getActiveAccount();
      });
    });
  }

  toggleTheme(): void {
    this.isDark.update((v) => !v);
    document.documentElement.setAttribute(
      'data-theme',
      this.isDark() ? 'dark' : 'light',
    );
  }
}
